import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FileText, LogOut, User as UserIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
    const { user, isAuthenticated, logout } = useAuth();

    return (
        <header className="header">
            <div className="container">
                <div className="header-content">
                    <Link to="/" className="logo">
                        <FileText size={32} />
                        <span className="logo-text">{import.meta.env.VITE_APP_TITLE}</span>
                    </Link>

                    <nav className="nav">
                        <NavLink to="/" className="nav-link" end>首页</NavLink>
                        <NavLink to="/convert" className="nav-link">转换</NavLink>
                        <NavLink to="/merge" className="nav-link">合并</NavLink>
                        <NavLink to="/split" className="nav-link">拆分</NavLink>
                        <NavLink to="/compress" className="nav-link">压缩</NavLink>
                        <NavLink to="/delete" className="nav-link">删除</NavLink>
                        <NavLink to="/pdf-to-image" className="nav-link">转图片</NavLink>
                        <NavLink to="/image-to-pdf" className="nav-link">图转PDF</NavLink>
                        <NavLink to="/translate" className="nav-link translate-link">翻译</NavLink>
                    </nav>

                    <div className="header-auth">
                        {isAuthenticated && user && (
                            <>
                                <div className="auth-user">
                                    <UserIcon size={18} />
                                    <span>{user.username}</span>
                                </div>
                                <button
                                    onClick={logout}
                                    className="auth-logout-btn"
                                >
                                    <LogOut size={16} /> 登出
                                </button>
                            </>
                        )}
                        {!isAuthenticated && (
                            <Link to="/login" className="auth-login-link">
                                登录
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
